import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

export const useUpdateWorkScheduleSlotTagMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      workScheduleSlotId,
      tag,
    }: {
      workScheduleSlotId: string;
      tag?: string;
    }) => {
      return http.workScheduleSlots
        .updateTag(workScheduleSlotId, { tag })
        .then((response) => response);
    },
    onSuccess: () => {
      // Invalidate office work schedule slots query
      queryClient.invalidateQueries({
        queryKey: ['office-work-schedule-slots'],
      });
      toast.success(t('http.update-work-schedule-slot-tag.success'));
    },
    onError: () => {
      toast.error(t('http.update-work-schedule-slot-tag.error'));
    },
  });
};
